export const SET_STEP = 'SET_STEP';
export const START_STEP = 'START_STEP';
export const PREV_STEP = 'PREV_STEP';
export const NEXT_STEP = 'NEXT_STEP';
export const FINISH_STEP = 'FINISH_STEP';
